<section>
  <div class="surface" [ngClass]="{ dialog: this.dialog }">
      <article>
        <p>
          This Cookies Policy explains how and why We use cookies and the choices You have to configure them. 
          It complements the Privacy Policy and is available on the platforms and websites:
        </p>
        <ul>
          <li>ARCHIPEL MARKET</li>
          <li>ARCHIPEL CONTENT</li>
          <li>MEDIA FINANCIERS</li>
          <li>BLOCKFRAMES</li>
        </ul>
        <p>(the "Websites")</p>
        <p>
          A "cookie" is a small text file containing data that is recorded on a terminal (computer, tablet, smartphone, etc.) 
          when You browse a website.
        </p>
        <p>
          The terms <strong>"You"</strong> / <strong>"Your"</strong> refers to the natural person reading this Cookie Policy, 
          whose Personal Data is being processed.
        </p>
        <p>
          The terms <strong>"We"</strong> / <strong>"Us"</strong> refers to CASCADE8.
        </p>
        <p>
          There are two main categories of cookies:
        </p>
        <ul>
          <li>
            Our cookies, i.e. the cookies We place on Your terminal. We generally use them to identify users, 
            make it easier for them to navigate the site and save their choices.
          </li>
          <li>
            Cookies placed by a third-party supplier. These cookies may be used by the third 
            party to recognize Your terminal when You visit other websites.
          </li>
        </ul>
      </article>
      <article>
        <h3>1. Our cookies</h3>
        <div class="table-wrapper">
          <table border="1px solid">
            <tr>
              <td>
                <p>
                  We use cookies and other similar tracking devices such as tags and web 
                  beacons on the Websites to:
                </p>
                <ul>
                  <li>Obtain information about Your preferences, Your online movements and Your use of the Internet in order to produce statistics and improve the ergonomics of the Websites, detect design problems on the Websites, communicate with You and build Our customer relationship. To do this, We use proven third-party solutions that respect your Personal Data;</li>
                  <li>Conduct statistical research and analysis to improve the content of the Websites and Our Services and to help Us better understand Your expectations and needs as an User. To do this, We use third-party solutions to analyze the statistics of visits to the Websites and to track Your interactions with the pages of the Websites;</li>
                  <li>To make Your online experience more functional and enjoyable</li>
                </ul>
              </td>
              <td>
                <p><i>Precisions</i></p>
                <p>
                  <i>
                    If You have accepted the storage of cookies on Your browser, 
                    the cookies embedded in the pages and content You have consulted 
                    may be stored temporarily in a dedicated area of Your browser. 
                    They will only be readable there by the sender. The length of time 
                    this information is kept varies from a few minutes to two years.
                  </i>
                </p>
              </td>
            </tr>
          </table>
        </div>       
      </article>
      <article>
        <h3>2. The cookies provided by third-parties</h3>
        <div class="table-wrapper">
          <table border="1px solid">
            <tr>
              <td>
                <p>
                  We work with third party suppliers such as Google Analytics who may also install 
                  cookies on the Websites for anonymized statistical and tracking purposes. 
                  These third parties are responsible for the cookies installed on the Websites.
                </p>
              </td>
              <td>
                <p><i>Precisions</i></p>
                <p>
                  <i>
                    The information collected via these third-party cookies may be transferred outside 
                    the European Union because some cookie suppliers have servers all over the world 
                    in order to ensure a better quality of service. If You would like more information, 
                    please consult the confidentiality policies of these third parties, which are available 
                    on their websites.
                  </i>
                </p>
              </td>
            </tr>
          </table>
        </div>       
      </article>
      <article>
        <h3>3. Categories of cookies</h3>
        <div class="table-wrapper">
          <table border="1px solid">
            <tr>
              <td>
                <p>
                  Essential cookies or cookies that do not store Personal Data
                </p>
                <mat-icon svgIcon="arrow_downward"></mat-icon>
                <p>
                  You cannot refuse them as they enable the Websites to function
                </p>
              </td>
              <td>
                <p>
                  These cookies are essential to the operation of the Websites and cannot be 
                  deactivated in Our systems. As they are strictly necessary for the provision 
                  of the Websites, You cannot refuse them without this having an impact on the 
                  operation of our Websites. In general, these cookies are only set in response 
                  to actions that You perform, such as defining Your preferences in terms of 
                  confidentiality, language or filling in forms. You can configure Your browser 
                  so that it blocks these cookies or alerts You to them, but certain parts of the 
                  Websites will not function. These cookies do not store any personally identifiable 
                  information.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Functional cookies (experience and relationship)
                </p>
                <mat-icon svgIcon="arrow_downward"></mat-icon>
                <p>
                  You may refuse them, but this could affect your browsing experience on the Websites
                </p>
              </td>
              <td>
                <p>
                  These cookies are used to improve the functionality of the Websites. 
                  They may be set by Us or by third-party suppliers whose services We have added to 
                  our Websites. You can refuse these cookies by not giving Your consent. If You do 
                  not authorize these cookies, some or all of these services may not function correctly.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Analysis, performance and personalisation cookies 
                </p>
                <mat-icon svgIcon="arrow_downward"></mat-icon>
                <p>
                  You may refuse them
                </p>
              </td>
              <td>
                <p>
                  These cookies enable us to count visits and sources of traffic so that we can 
                  measure and improve the performance of our Site. They help us understand how 
                  our Site is used so that we can make changes to our Site to improve your experience.
                  These are non-essential cookies managed by the cookies banner. You can refuse these
                  cookies by not giving your consent.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Marketing cookies de marketing, for targeted advertising
                </p>
                <mat-icon svgIcon="arrow_downward"></mat-icon>
                <p>
                  You may refuse them
                </p>
              </td>
              <td>
                <p>
                  These cookies are used to make advertising more relevant to You. They may be used
                  by Our advertising partners to profile Your interests and show You relevant
                  advertising on other sites. They do not directly store personal information
                  but are based on the unique identification of Your browser and internet device. 
                  You can refuse these cookies by not giving Your consent. If You do not authorize 
                  these cookies, You will see less targeted advertising.
                </p>
              </td>
            </tr>
          </table>
        </div>       
      </article>
      <article>
        <h3>4. Desactivation of cookies</h3>
        <p>
          Cookies have an important role in the operation of our Services. 
          Deactivating them could (particularly in the case of technical cookies) 
          have the effect of reducing or preventing access to all or part of our Services.
        </p>
        <p>If You are not satisfied with the use made of cookies:</p>
        <ul>
          <li>
            You can delete them easily by accessing Your browser's cookies folder.
            You can also configure Your browser so that it blocks cookies or sends an
            alert message before a cookie is installed on Your computer.
          </li>
          <li>
            You can find out more, configure Your cookies, and accept or reject them
            at any time by visiting the Webites' cookie management page, the link to which
            can be found at the bottom of each page of the Websites (footer). You will be
            able to indicate Your overall preferences for the Websites', either by purpose
            or by third-party service provider.
          </li>
        </ul>
      </article>
  </div>
</section>